import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import type { BulkAdScheduledActionsUpdate } from "../../../zodios/apiDefinitions/api/ads";
import { errorToast, successToast } from "utils/toasts";

export function useBulkAdScheduledActionsUpdate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: { data: BulkAdScheduledActionsUpdate; isLast: boolean }) => {
      return await apiClient.updateAdScheduledActions(vars.data);
    },
    onSuccess: (data, vars) => {
      if (vars.isLast) {
        successToast({ message: `Media Plan${vars.data.gvadvertisements_set.length > 1 ? "s" : ""} Updated` });
        // TODO: shouldn't invalidate _all_ queries
        void queryClient.invalidateQueries();
      }
    },
    onError: (
      error: {
        response?: {
          data?: {
            non_field_errors?: string[];
          };
        };
      },
      vars,
    ) => {
      const errorDetails = error.response?.data?.non_field_errors ?? [];
      const adIds = vars.data.gvadvertisements_set;

      if (errorDetails.join("").includes("Date range overlaps with another scheduled action")) {
        errorToast({
          message: `Failed to create scheduled update for media plan${adIds.length === 1 ? "" : "s"} ${adIds.join(",")}. The selected date range collides with a previously scheduled action.`,
          error,
        });
        return;
      }

      if (vars.isLast) {
        errorToast({ message: `Failed to update Media Plan${vars.data.gvadvertisements_set.length === 1 ? "" : "s"}` });
      }
    },
  });
}
